import { Alert, DatePicker, Col } from "antd";
import { StyledForm } from "../styles";
import FormInputDivider from "./FormInputDivider";
import DateUtils from "utils/date";

function PortalDatePicker({input, divider, form, date, colSpan, ...props}){
    const dateFormat = 'DD/MM/YYYY';
    return(
        <FormInputDivider key={input.name} {...divider}>
            <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name}>
                <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
                        <StyledForm.Item {...input} extra={props.helpMessage} rules={[
                            ...(input?.rules || []),
                            ({}) =>({
                            validator(_, value){
                                if(value == null){
                                    return Promise.resolve();
                                }
                                let valueDate = new Date(value);

                                if(date?.rules?.minDate){
                                    let minDate = new Date(date.rules.minDate)
                                    if(valueDate < minDate){
                                        return Promise.reject(`Data deve ser maior que ${DateUtils.DateFormat(minDate)}!`)
                                    }
                                }
                                if(date?.rules?.maxDate){
                                    let maxDate = new Date(date.rules.maxDate)
                                    if(valueDate > maxDate){
                                        return Promise.reject(`Data deve ser menor que ${DateUtils.DateFormat(maxDate)}!`)
                                    }
                                }
                                return Promise.resolve();
                            }
                        })
                        ]}>
                            <DatePicker disabled={input?.disabled} format={dateFormat} placeholder={input?.disabled ? "" : "Selecione"} />
                        </StyledForm.Item>
                </Col>
            </Col>
        </FormInputDivider>
    )
}

export default PortalDatePicker;